// Query-key factory for the admin Prompts surface. Lives in its own *Keys file
// so the stale-after-save convention recognises it (the gate skips files matching
// /[Kk]eys\.tsx?$/) and the copy mutation can invalidate the whole surface by the
// `all` prefix.

export const promptKeys = {
  all: ["prompts"] as const,
  catalog: () => ["prompts", "catalog"] as const,
  configurations: () => ["prompts", "configurations"] as const,
  reconciliation: () => ["prompts", "reconciliation"] as const,
  definition: (key: string) => ["prompts", "definition", key] as const,
};
